export const pageview = () => {
  window.pintrk('track', 'pagevisit')
}

export const event = (name, options = {}) => {
  window.pintrk('track', name, options)
}
